import * as types from './types';

export const setModalData = payload => ({
  type: types.SET_MODAL_DATA,
  payload,
});

export const setEditableItem = payload => ({
  type: types.SET_EDITABLE_ITEM,
  payload
});

export const getCategories = payload => ({
  type: types.GET_CATEGORIES_REQUEST,
  payload,
});

export const setCurrentRestaurant = payload => ({
  type: types.SET_CURRENT_RESTAURANT,
  payload,
});

export const getStripeLink = () => ({
  type: types.GET_STRIPE_LINK_REQUEST,
});

export const resetState = () => ({
  type: types.RESET_STORE,
});

// Visible lists management
export const setVisibleLists = (lists) => ({
  type: types.SET_VISIBLE_LISTS,
  payload: lists,
});

export const addVisibleList = (listId) => ({
  type: types.ADD_VISIBLE_LIST,
  payload: listId,
});

export const removeVisibleList = (listId) => ({
  type: types.REMOVE_VISIBLE_LIST,
  payload: listId,
});

export const resetVisibleLists = () => ({
  type: types.RESET_VISIBLE_LISTS,
});

export const setHasEnteredMenu = (hasEntered) => ({
  type: types.SET_HAS_ENTERED_MENU,
  payload: hasEntered,
});
